import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Box, Button, CircularProgress } from "@mui/material";
import AppContext from "../../contexts/appContext";
import ApiServices from "../../services";
import handleError from "../../services/handleError";
import PDFApproval from "./index";
import PDFApprovalClassic from "./Classic";

const SignPageWrapper = () => {
  const { unique, token } = useParams();
  const {
    state: { auth },
    dispatch,
  } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [signClassic, setSignClassic] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!auth.token) {
      return;
    }

    const fetchDocumentDetails = async () => {
      try {
        setLoading(true);
        const res = await ApiServices.getData(
          { usrToken: auth.token },
          { unique, token }
        );

        if (res.success === true) {
          // Check if sign_classic is true in the payload
          setSignClassic(res.payload.sign_classic === true);
          setLoading(false);
        } else {
          setError(res.code || "Failed to load document");
          handleError(res.code, dispatch);
          setLoading(false);
        }
      } catch (err) {
        console.error("Error fetching document details:", err);
        setError("Failed to load document");
        setLoading(false);
      }
    };

    fetchDocumentDetails();
  }, [unique, token, auth.token, dispatch]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <p>Error loading document. Please try again.</p>
        <Button variant="outlined" color="primary" onClick={() => window.location.reload()}>Reload</Button>
        <Link to="/app/approvals" variant="contained" color="primary">All Approvals</Link>
      </Box>
    );
  }

  // Conditionally render based on sign_classic flag
  return signClassic ? <PDFApprovalClassic /> : <PDFApproval />;
};

export default SignPageWrapper;

